import type React from 'react';

import { Accordion, Anchor, Heading, Text } from '@zillow/constellation-10';

import type { FaqSection } from '../../models/Types';

type Props = {
  children?: React.ReactNode;
  title: string;
  link?: string;
  initialExpandedIndex?: number;
  sections: Array<FaqSection>;
};

export default function FaqAccordion({ children, title, link, initialExpandedIndex, sections }: Props): JSX.Element {
  function renderTitle(title: string): React.ReactNode {
    return (
      <Heading
        className="title"
        css={{
          paddingBottom: 'tighter',
          textStyle:
            'responsive.heading-xs' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
        }}
        level={2}
      >
        {title}
      </Heading>
    );
  }

  function renderSections(): React.ReactNode {
    return (
      <Accordion.Root defaultExpanded={initialExpandedIndex != null ? initialExpandedIndex.toString() : undefined}>
        {sections.map(({ label, description }, index) => (
          <Accordion.Item key={index} value={index.toString()}>
            <Accordion.Header>
              <Heading
                level={3}
                css={{
                  textStyle:
                    'responsive.body-bold' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
                }}
              >
                {label}
              </Heading>
            </Accordion.Header>
            <Accordion.Panel>
              <Text>
                {typeof description === 'string' ? (
                  <>
                    {description}
                    {link && (
                      <>
                        {' '}
                        <Anchor target="_blank" href={link} rel="noopener noreferrer">
                          Learn more
                        </Anchor>
                      </>
                    )}
                  </>
                ) : (
                  description
                )}
              </Text>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    );
  }
  return (
    <>
      {children ? children : null}
      {title && renderTitle(title)}
      {renderSections()}
    </>
  );
}
